// extracted by mini-css-extract-plugin
export default {"icon":"eventReaction_icon__ZY4Os","eventReaction":"eventReaction_eventReaction__k+gGp"};